import React, { useEffect, useRef, useState } from "react";
import { generateRandomMessage, updateDynamicBoats } from "./BookingFomoMessagesData";
import BoatService from "../../services/BoatService";
import { useNavigate } from "react-router-dom";
import { generateBoatUrl } from "../../utils/stringUtils";

const BookingFomoPopup = () => {
  const [visible, setVisible] = useState(false);
  const [message, setMessage] = useState(generateRandomMessage());
  const [lastMessage, setLastMessage] = useState(null);
  const [boatsLoaded, setBoatsLoaded] = useState(false);
  const navigate = useNavigate();

  const getUniqueMessage = () => {
    let newMessage = generateRandomMessage();
    while (
      lastMessage &&
      newMessage.name === lastMessage.name &&
      newMessage.city === lastMessage.city &&
      newMessage.boat === lastMessage.boat
    ) {
      newMessage = generateRandomMessage();
    }
    return newMessage;
  };

  // Función para manejar el click en el nombre del barco
  const handleBoatClick = (boatId, boatName) => {
    if (boatId && boatName) {
      const boatUrl = generateBoatUrl({ id: boatId, name: boatName });
      navigate(boatUrl);
    }
  };

  // Cargar barcos de la base de datos
  const loadBoatsFromDatabase = async () => {
    try {
      const boats = await BoatService.fetchBoatNamesForFomo();
      updateDynamicBoats(boats);
      setBoatsLoaded(true);
      console.log('FOMO boats loaded from database:', boats.length, 'boats');
    } catch (error) {
      console.error('Error loading FOMO boats:', error);
      setBoatsLoaded(true); // Continuar con fallback
    }
  };

  useEffect(() => {
    let firstTimeout, repeatInterval;

    // Cargar barcos de la base de datos inmediatamente
    loadBoatsFromDatabase();

    // Mostrar el popup por primera vez a los 15 segundos
    firstTimeout = setTimeout(() => {
      const newMessage = getUniqueMessage();
      setMessage(newMessage);
      setLastMessage(newMessage);
      setVisible(true);
      // Ocultar después de 5 segundos
      setTimeout(() => setVisible(false), 5000);

      // Luego, mostrar cada 60 segundos
      repeatInterval = setInterval(() => {
        const newMsg = getUniqueMessage();
        setMessage(newMsg);
        setLastMessage(newMsg);
        setVisible(true);
        setTimeout(() => setVisible(false), 6000);
      }, 60000);
    }, 15000);

    return () => {
      clearTimeout(firstTimeout);
      clearInterval(repeatInterval);
    };
  }, []);

  if (!visible) return null;

  return (
    <div className="booking-fomo-popup fixed">
      <div className="booking-fomo-message">
        {message.flag}{" "}
        <span className="highlight">{message.name}</span> from{" "}
        <span className="highlight">{message.city}</span> just booked the{" "}
        <span 
          className="highlight boat-name-clickable" 
          onClick={() => handleBoatClick(message.boatId, message.boat)}
        >
          {message.boat}
        </span>
      </div>
      <div className="booking-fomo-time">
        {message.time}
      </div>
    </div>
  );
};

export default BookingFomoPopup;